module.exports = __webpack_public_path__ + "img/0080.db55f2ca.jpg";